module.exports = __webpack_public_path__ + "8c559a060a3306399b51c2ae72f171f3.png";